import Vue from 'vue'

export default function getTeachermissings({ schoolyear, teacherId }) {
    const proxy = process.env.VUE_APP_PROXY
    const api_uri = process.env.VUE_APP_API_URI

    let url = proxy + api_uri + "/teachers/" + teacherId + "/missing"
    if (schoolyear) {
        let q = new URLSearchParams({ schoolyear }).toString()
        url += `?${q}`
    }
    return Vue.http
        .get(url, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
}